import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {RootState} from './store'
import { IPriorityProducts } from '../interface/IOrders_Tasks';


const ProductSlice = createSlice({
  name: 'ProductSliceData',
   initialState: [
     {
       "id": "41",
       "PARTNAME": "CL15C",
       "BARCODE": "856282004027",
       "PART": 19,
       "PARTDES": "kcoL elbaC delioC rab-T deyeK",
       LOCATION: "",
     }
   ] as IPriorityProducts[],
  reducers: {
    
    
    incrementProducts: (state, action: PayloadAction<IPriorityProducts[]>) => {   
      
      state = [] as IPriorityProducts[];    
      action.payload.forEach(function(ts) {
       
       state.push(ts as IPriorityProducts);
   });
           
      return state;
   }
  },
})



// Action creators are generated for each case reducer function
export const {   incrementProducts } = ProductSlice.actions
export const ProductSliceData = (state: RootState)=>state
export default ProductSlice.reducer